import infos from './infoCreche.ducks'
import ajout_enfant from './creche.ducks'
import planningCreche from './planningCreche.ducks'
import staffPlan from './staffPlan.ducks'
import archiveEnfants from './archiveEnfants.ducks'
import sections from './sections.ducks'

 import { combineReducers } from "redux";

export default combineReducers({infos, ajout_enfant,planningCreche,staffPlan,archiveEnfants,sections})

 